export const searchTermConstants = {
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
}
